import type {
  PaymentStatus,
  RewardStatus,
  RewardType,
  SignupSource,
} from "@/utils/api/referrals";

/**
 * Convert raw reward status to human-readable format
 */
export const getRewardStatusDisplay = (status: RewardStatus): string => {
  const statusMap: Record<RewardStatus, string> = {
    not_started: "Not Started",
    pending: "Pending",
    fraud_review_pending: "Under Fraud Review",
    fraud_review_passed: "Fraud Review Passed",
    fraud_review_blocked: "Blocked by Fraud Review",
    delivery_success: "Delivered",
    delivery_failed: "Delivery Failed",
    cancelled: "Cancelled",
  };
  return statusMap[status] || status;
};

/**
 * Convert payment status to human-readable format
 */
export const getPaymentStatusDisplay = (status: PaymentStatus): string => {
  const statusMap: Record<PaymentStatus, string> = {
    not_started: "Not Started",
    partial: "Partial Payment",
    paid: "Fully Paid",
  };
  return statusMap[status];
};

/**
 * Convert signup source to human-readable format
 */
export const getSignupSourceDisplay = (source: SignupSource): string => {
  if (!source) return "Lead";
  const sourceMap: Record<string, string> = {
    lead: "Lead",
    installments_promo: "Installments",
    full_signup: "Full Signup",
    pay_by_refund: "Pay by Prep Fees",
  };
  return sourceMap[source] || source;
};

/**
 * Convert reward type to human-readable format
 */
export const getRewardTypeDisplay = (type: RewardType | null): string => {
  if (!type) return "-";
  const typeMap: Record<RewardType, string> = {
    promo_signup: "Promo Signup (25%)",
    full_signup: "Full Signup (100%)",
    promo_complete: "Promo Complete (75%)",
  };
  return typeMap[type] || type;
};
